var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('PageHeaderDesktop'),(!_vm.$store.state.showArticleOnly)?_c('TopMenu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }